import { useState, useEffect, useCallback } from "react";
// import { loadModel, loadExtractor } from './utils/inference.js'
import * as tf from "@tensorflow/tfjs";
import { EssentiaWASM, EssentiaModel } from "essentia.js";
import MoodResults from "./MoodResults.jsx";
import Loading from "./Loading.jsx";
import AudioComponent from "./AudioComponent.jsx";
import Paintings from "./Paintings.jsx";

function App() {
  const [model, setModel] = useState(null);
  const [extractor, setExtractor] = useState(null);
  const [audioData, setAudioData] = useState(null);
  const [predictions, setPredictions] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadModel();
    loadExtractor();
  }, []);

  const loadModel = async () => {
    try {
      const modelUrl = "moods_mirex-musicnn-msd-1/model.json";
      const loadedModel = new EssentiaModel.TensorflowMusiCNN(
        tf,
        modelUrl,
        true
      );
      await loadedModel.initialize();
      setModel(loadedModel);
    } catch (error) {
      console.error("Error loading model:", error);
    }
  };

  const loadExtractor = () => {
    const loadedExtractor = new EssentiaModel.EssentiaTFInputExtractor(
      EssentiaWASM.EssentiaWASM,
      "musicnn",
      false
    );
    setExtractor(loadedExtractor);
  };

  const analyse = useCallback(async () => {
    if (!audioData) {
      console.error("No audio data to analyze");
      return;
    }

    try {
      const audio = new Float32Array(audioData.buffer);
      const features = await extractor.computeFrameWise(audio, 256);
      console.log(features);
      const predictions = await model.predict(features, true);
      const predictionsArray = Array.from(predictions[0]);
      setPredictions(predictionsArray);
      setAudioData(null);
    } catch (error) {
      console.error("Error during analysis:", error);
    } finally {
      setLoading(false);
    }
  }, [audioData, extractor, model]);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        analyse();
      }, 0);
    }
  }, [loading, analyse]);

  return (
    <div className="h-screen flex justify-center">
      <div className="w-4/5 flex flex-row bg-gray-50">
        <div className="w-1/2 flex flex-col border-r-4">
          <div className="h-1/2 flex flex-col border-b-4">
            <AudioComponent
              audioData={audioData}
              setAudioData={setAudioData}
              setLoading={setLoading}
              setPredictions={setPredictions}
            />
          </div>
          <div className="h-1/2 flex flex-col items-center justify-center">
            {loading && <Loading />}
            {predictions && <MoodResults predictions={predictions} />}
          </div>
        </div>
        <div className="w-1/2">
          <Paintings predictions={predictions} />
        </div>
      </div>
    </div>
  );
}

export default App;
